import { connect } from 'react-redux';

import styles from '../../styles/user/UserProfile.module.scss';
import { EditPageIcon } from '../../services/SvgLibrary';
import UserForm from '../user/UserForm';

const ProfileInfoCard = ({ localState, userProfile, users }) => {
  const { selectedStaff } = localState;
  const under_council_member = selectedStaff?.under_council_member;
  const associated_cm = selectedStaff?.is_council_member
    ? selectedStaff
    : selectedStaff?.under_council_member;

  const staffers = associated_cm
    ? users.filter(staff => associated_cm.id === staff.under_council_member?.id)
    : [];

  return (
    <div className={styles['user-profile-info-panel']}>
      {!selectedStaff ? (
        <div className={styles['image-and-text-placeholder']}>
          <img src='/img/central-staff-icon.png' alt='User profile icon' />
          <h1>Staff Directory</h1>
        </div>
      ) : (
        <div>
          <div className='card' style={{ border: '0px', marginBottom: '25px' }}>
            <img
              src='/img/my-profile-cover-image.jpg'
              className={`card-img-top ${styles['staff-directory-cover-image']}`}
              aria-hidden='true'
              alt='Placeholder user profile banner'
            />
            <h1 className={styles['users-name']}>{selectedStaff.full_name}</h1>
            <img
              src={`${
                selectedStaff.profile_pic_icon
                  ? selectedStaff.profile_pic_icon.file
                  : '/img/profile-image-placeholder.png'
              }`}
              onError={e => {
                e.target.onerror = null;
                e.target.src = '/img/profile-image-placeholder.png';
              }}
              className={styles['staff-directory-profile']}
              alt='User profile icon'
            />
            {userProfile.permissions.auth.change_user ? (
              <button
                type='button'
                className={styles['edit-profile-button']}
                data-bs-toggle='modal'
                data-bs-target='#editCMUserProfile'>
                <EditPageIcon /> Edit Profile
              </button>
            ) : null}
            <div className='card-body'>
              <table className={styles['staff-directory-details']}>
                <tbody>
                  {userProfile.permissions.auth.change_user &&
                    !selectedStaff.is_active && (
                      <tr>
                        <td colSpan='2'>
                          <strong>DEACTIVATED</strong>
                        </td>
                      </tr>
                    )}
                  <tr>
                    <td>Username</td>
                    <td>{selectedStaff.username}</td>
                  </tr>
                  {userProfile.is_web_dev && (
                    <tr>
                      <td>Role</td>
                      <td>{selectedStaff.role}</td>
                    </tr>
                  )}

                  <tr>
                    <td>Title</td>
                    <td>{selectedStaff.title}</td>
                  </tr>

                  <tr>
                    <td>Email</td>
                    <td>
                      <a
                        href={`mailto:${selectedStaff.email}`}
                        style={{ color: '#4e46d2' }}>
                        {selectedStaff.email}
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{selectedStaff.phone}</td>
                  </tr>
                  <tr>
                    <td>Alternative Phone</td>
                    <td>{selectedStaff.alternative_phone || 'N/A'}</td>
                  </tr>
                  {/* {selectedStaff.desk_number &&
                    userProfile.desk_number && (
                      <tr>
                        <td>Desk Number</td>
                        <td>
                          {userProfile.bio && userProfile.profile_pic ? (
                            <Link
                              to='/seating'
                              state={{
                                selectedStaff: selectedStaff,
                              }}>
                              {selectedStaff.desk_number}
                            </Link>
                          ) : (
                            <a
                              href='#'
                              onClick={e => {
                                e.preventDefault();
                                alert(
                                  'ERROR! \n401 UNAUTHORIZED! \nUpdate your bio AND profile picture to see the floor plan!'
                                );
                              }}>
                              {selectedStaff.desk_number}
                            </a>
                          )}
                        </td>
                      </tr>
                    )} */}
                </tbody>
              </table>
            </div>
          </div>
          {selectedStaff.bio && (
            <div className='card mb-4 border-0 rounded-3'>
              <div className='card-body'>
                <h2>Bio</h2>
                <p>{selectedStaff.bio}</p>
              </div>
            </div>
          )}
          <div className='card' id={styles['staff-associations']}>
            <div className='card-body'>
              <table className='w-100'>
                <tbody>
                  {under_council_member && (
                    <tr>
                      <td className={styles['association-label-top']}>
                        Associated CM:
                      </td>
                      <td>
                        <a href={`/staff/${under_council_member.id}`}>
                          {under_council_member.full_name}
                        </a>
                      </td>
                    </tr>
                  )}
                  {staffers.length > 0 &&
                    (selectedStaff.is_council_member ||
                      selectedStaff.role.includes('Council Member') ||
                      selectedStaff.role.includes('Public Advocate')) && (
                      <tr>
                        <td className={styles['association-label-top']}>
                          Staffers:
                        </td>
                        <td>
                          <ul className='px-0'>
                            {staffers.map((staffer, idx) => (
                              <li key={idx}>
                                <a
                                  href={`/staff/${staffer.id}`}
                                  style={{
                                    textDecoration:
                                      userProfile.permissions.auth
                                        .change_user && !staffer.is_active
                                        ? 'line-through'
                                        : '',
                                  }}>
                                  {staffer.full_name}
                                </a>
                                {userProfile.permissions.auth.change_user &&
                                  !staffer.is_active && (
                                    <strong>&#91;DEACTIVATED&#93;</strong>
                                  )}
                              </li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    )}

                  {selectedStaff.divisions && (
                    <tr>
                      <td className={styles['association-label-top']}>
                        Division/Teams:
                      </td>
                      <td>
                        {' '}
                        {/* FIX THE STYLING HERE */}
                        {selectedStaff.divisions?.length === 1 &&
                        selectedStaff.divisions[0].division_name ===
                          'Unassigned' ? (
                          'None assigned'
                        ) : (
                          <ul className='px-0'>
                            {selectedStaff.divisions.map((div, idx) => (
                              <li key={idx}>{div.division_name}</li>
                            ))}
                          </ul>
                        )}
                      </td>
                    </tr>
                  )}

                  {selectedStaff.committees?.length > 0 && (
                    <tr>
                      <td className={styles['association-label-top']}>
                        Committees:
                      </td>
                      <td>
                        {' '}
                        {/* FIX THE STYLING HERE */}
                        {selectedStaff.committees?.length === 1 &&
                        selectedStaff.committees[0].committee_name ===
                          'Unassigned' ? (
                          'None assigned'
                        ) : (
                          <ul className='px-0'>
                            {selectedStaff.committees &&
                              selectedStaff.committees.map((committee, idx) => (
                                <li key={idx}>{committee.committee_name}</li>
                              ))}
                          </ul>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className='modal fade'
            id='editCMUserProfile'
            data-bs-backdrop='static'
            data-bs-keyboard='false'
            tabIndex='-1'
            aria-labelledby='editUserProfile'
            aria-hidden='true'>
            <div className='modal-dialog modal-lg'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title' id='editUserProfile'>
                    Edit profile
                  </h5>
                  <button
                    type='button'
                    className='btn-close'
                    data-bs-dismiss='modal'
                    aria-label='Close'></button>
                </div>
                <div className='modal-body' style={{ padding: '0px' }}>
                  <UserForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  users: state.userReducer.userProfile.permissions.auth.change_user
    ? state.userReducer.allUserList
    : state.userReducer.userList,
  userProfile: state.userReducer.userProfile,
});

export default connect(mapStateToProps)(ProfileInfoCard);
